/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Simple client-side form validation stuff

namespace('Slzr.FormValidation', function(exports, top) {
  let jQuery;
  const $ = (jQuery = Slzr.jQuery);

  const VALIDATION_SELECTOR = [
    'input[data-validation]',
    'input[required]',
    'input[data-required="true"]',
    'textarea[data-required="true"]',
    'textarea[data-validation]',
    'textarea[required]',
    'select[data-validation]',
    'select[required]',
  ].join(',');

  let validationErrorIdCounter = 0;

  // Implements simple input validation on a form
  //
  // The inputs to validate are given a data-validation attribute, with the
  // validation type (required, email, matches).
  //
  // Other data attributes configure behavior:
  //   data-validation-match:     For matches validation, the other input to match
  //   data-validation-error:     Selector for element to show when input is not valid
  //   data-validation-add-class: Add the specified class to elements matching data-validation-add-class-to when not valid
  //   data-validation-add-class-to: Selector to add class to
  //
  // Triggers a validation:complete event on the form when validation is complete.
  // This event has these parameters:
  //   form: Form that is being validated
  //   valid: Result of the validation
  //   errors: List of errors during validation (string array, legacy)
  //   structuredErrors: Array of { fieldId, fieldName, message } for ErrorSummary
  // Any additional errors in this field should be appended to errors.

  const Cls = (exports.FormValidator = class FormValidator {
    static initClass() {
      this.prototype.form = null;
      this.prototype.inputs = null;
    }

    constructor(form) {
      this.validateForm = this.validateForm.bind(this);
      this.form = $(form);
      this.form.submit(this.validateForm);
      if (this.form.data('inline-validation')) {
        this._bindInlineValidation();
      }
    }

    // ── Shared single-field helpers ──────────────────────────────────────

    // Determine the validation type for an input element.
    _resolveValidationType($input) {
      let type = $input.data('validation');
      if (!type && $input.prop('required')) { type = 'required'; }
      if (!type && ($input.data('required') === true)) { type = 'required'; }
      return type || null;
    }

    // Read the current value from an input, handling CKEditor.
    _getFieldValue($input) {
      if ($input.data('ckeditor-instance')) {
        const snapshot = $input.data('ckeditor-instance').getSnapshot();
        return $(snapshot).text();
      }
      return $input.val();
    }

    // Returns true when the field value satisfies its validation rule.
    _isFieldValid($input, validation_type, val) {
      switch (validation_type) {
        case 'required':          return !val.isBlank();
        case 'email':             return !!val.match(/^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+\.[A-Za-z0-9-.]+$/i);
        case 'matches':
          var $other = this.form.find($input.data('validation-match'));
          return !val.isBlank() && val === $other.val();
        case 'urlname':
          return (val.isBlank() && $input.data('validation-allow-blank')) ||
                 !!val.trim().match(/^[-_A-Za-z0-9]+$/i);
        case 'required_checkbox': return $input.is(':checked');
        default:                  return null; // unknown type
      }
    }

    // Locate the error message element for a field.
    _findErrorElement($input) {
      const $form = this.form;
      const my_id = $input[0].id || $input[0].name;

      let $error;
      if ($input.data('validation-error')) {
        $error = $form.find($input.data('validation-error'));
      } else {
        $error = $form.find(`[data-validation-error-message-for='${my_id}']`);
        if (!$error.get(0)) { $error = $form.find(`#x-need-${my_id}`); }
      }

      const text_el = $error.filter('p,span').get(0);
      if (text_el && !text_el.id) {
        validationErrorIdCounter += 1;
        text_el.id = `x-validation-error-message-${validationErrorIdCounter}`;
      }

      return { $error, text_el };
    }

    // Show or hide the error for a single field and update ARIA attributes.
    _applyFieldState($input, is_ok, $error, error_text_el) {
      const $form = this.form;
      const data = $input.data();

      if ($error && $error.length) { $error.toggle(!is_ok); }

      if (data.validationAddClass && data.validationAddClassTo) {
        $form.find(data.validationAddClassTo).toggleClass(data.validationAddClass, !is_ok);
      }

      $input.attr('aria-invalid', !is_ok);
      $input.attr('aria-describedby', is_ok ? null : (error_text_el ? error_text_el.id : undefined));

      // Propagate ARIA to the visible focus target so screen readers
      // announce the error on the control the user interacts with (WCAG 3.3.1)
      var focusSelector = data.validationFocus;
      if (focusSelector) {
        var $focusTarget = $(focusSelector).first();
        if ($focusTarget.length) {
          if ($focusTarget.data('orig-describedby') === undefined) {
            $focusTarget.data('orig-describedby', $focusTarget.attr('aria-describedby') || '');
          }
          $focusTarget.attr('aria-invalid', !is_ok);
          var origDesc = $focusTarget.data('orig-describedby');
          if (!is_ok && error_text_el) {
            $focusTarget.attr('aria-describedby', (origDesc + ' ' + error_text_el.id).trim());
          } else if (origDesc) {
            $focusTarget.attr('aria-describedby', origDesc);
          } else {
            $focusTarget.removeAttr('aria-describedby');
          }
        }
      }
    }

    // ── Inline (blur/change) validation ─────────────────────────────────

    // Bind blur/change handlers that validate individual fields inline.
    // Once a field has been focused ("touched"), leaving it blank shows
    // the error immediately — the user doesn't have to submit first.
    _bindInlineValidation() {
      const self = this;
      const $form = this.form;

      // Mark a field as touched on first focus so we don't flash errors
      // on fields the user hasn't visited yet.
      $form.on('focusin', VALIDATION_SELECTOR, function () {
        $(this).data('slzr-touched', true);
      });

      // Validate on blur (field lost focus) and change (select / hidden input)
      $form.on('blur change', VALIDATION_SELECTOR, function () {
        self._validateFieldInline($(this));
      });

      // Hidden inputs (e.g. filter combobox sentinels) never receive focus,
      // but their value is updated programmatically with a 'change' event.
      // Treat any change as "touched".
      $form.on('change', 'input[type="hidden"][data-validation]', function () {
        const $el = $(this);
        $el.data('slzr-touched', true);
        self._validateFieldInline($el);
      });

      // CKEditor replaces textareas — bind to the editor's own events.
      this._bindCKEditorInline();
    }

    _bindCKEditorInline() {
      const self = this;
      const $form = this.form;

      const bindEditor = function (editor) {
        const $textarea = $form.find('#' + editor.name);
        if (!$textarea.length) { return; }

        editor.on('focus', function () {
          $textarea.data('slzr-touched', true);
        });
        editor.on('blur', function () {
          self._validateFieldInline($textarea);
        });
      };

      $form.find('textarea[data-validation], textarea[data-required="true"]').each(function () {
        const inst = $(this).data('ckeditor-instance');
        if (inst && inst.status === 'ready') {
          bindEditor(inst);
        }
      });

      if (typeof CKEDITOR !== 'undefined') {
        CKEDITOR.on('instanceReady', function (evt) {
          bindEditor(evt.editor);
        });
      }
    }

    // Validate a single field inline.  Shows the error if the field is
    // touched and invalid; hides it if valid.  Skips fields the user
    // hasn't interacted with yet.
    _validateFieldInline($input) {
      if (!$input.data('slzr-touched')) { return; }

      const validation_type = this._resolveValidationType($input);
      if (!validation_type) { return; }

      const val = this._getFieldValue($input);
      const is_ok = this._isFieldValid($input, validation_type, val);
      if (is_ok === null) { return; } // unknown type

      const { $error, text_el } = this._findErrorElement($input);
      this._applyFieldState($input, is_ok, $error, text_el);
    }

    // ── Submit validation ───────────────────────────────────────────────

    validateForm(evt) {
      const errors = [];
      const structuredErrors = [];
      const $form = this.form;
      const self = this;

      $form.trigger('validation:before');

      $form.find(VALIDATION_SELECTOR).each(function() {
        const $input = $(this);

        const validation_type = self._resolveValidationType($input);
        if (!validation_type) { return; }

        const val = self._getFieldValue($input);
        const is_ok = self._isFieldValid($input, validation_type, val);

        if (is_ok === null) {
          console.error('Unknown validation type', validation_type, 'on', this);
          return;
        }

        const { $error, text_el } = self._findErrorElement($input);
        self._applyFieldState($input, is_ok, $error, text_el);

        // Mark the field as touched so inline validation stays active
        // after the first submit attempt.
        $input.data('slzr-touched', true);

        if (!is_ok) {
          const my_id = this.id || this.name;
          errors.push(`${$input.attr('id')} is required`);

          // Collect structured error data for ErrorSummary consumers
          var fieldLabel = $input.data('validation-label');
          if (!fieldLabel) {
            var $label = $form.find(`label[for='${my_id}']`);
            if ($label.length) {
              fieldLabel = $label.first().text().replace(/\s*(REQUIRED|required|\*)\s*/g, '').trim();
            }
          }
          structuredErrors.push({
            fieldId: my_id,
            fieldName: fieldLabel || my_id,
            message: text_el ? text_el.textContent.trim() : 'This field is required.'
          });
        }
      });

      $form.triggerHandler('validation:complete', {validator: this, form: $form, errors, structuredErrors});

      if (errors.length > 0) {
        // Move focus to the first invalid field (WCAG 2.4.3 Focus Order)
        var $firstInvalid = $form.find('[aria-invalid="true"]').first();
        if ($firstInvalid.length) {
          // Hidden inputs can't receive focus — use data-validation-focus target
          var focusTarget = $firstInvalid.data('validation-focus');
          if (focusTarget) {
            var $target = $(focusTarget).first();
            if ($target.length) { $target.trigger('focus'); }
          } else {
            $firstInvalid.trigger('focus');
          }
        }
        evt.preventDefault();
        return false;
      } 
        return true;
      
    }
  });
  Cls.initClass();


  // Attach to all forms with data-validation and internal elements
  return $(() => $('form[data-validation]').each(function() {
    const $form = $(this);
    if (!$form.data('slzr.validator') && ($form.find(VALIDATION_SELECTOR).length > 0)) {
      const validator = new exports.FormValidator($form);
      return $form.data('slzr.validator', validator);
    }
  }));
});
